import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import SwarmStudio from "./lightshow/SwarmStudio";
import "./global.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SwarmStudio />
  </StrictMode>
);
